import { getPlatformVerticalTitle } from "components/financials/modern/utils/platformVertical";
import LogoGrid from "components/pages/shared/LogoGrid";
import { Separator } from "components/ui/Separator";
import classNames from "components/ui/classNames";
import { FormattedMessage } from "react-intl";
import type { IPlatformVertical } from "types/graphqlTypes";
interface MastheadProps {
  vertical: IPlatformVertical | null;
}
export default function Masthead({ vertical }: MastheadProps) {
  return (
    <div className="bg-neutral-50 dark:bg-slate-800">
      <div className="relative isolate overflow-hidden">
        <svg
          className="absolute inset-0 -z-10 h-full w-full stroke-slate-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)] dark:stroke-slate-600"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="549c0dfa-9a7b-4bbc-bfab-3e301b4162db"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M.5 200V.5H200" fill="none" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" strokeWidth={0} fill="url(#549c0dfa-9a7b-4bbc-bfab-3e301b4162db)" />
        </svg>

        <LogoGrid
          width={128}
          height={128}
          className={classNames(
            "absolute -right-60 top-0 -z-10 h-full w-full",
            "opacity-80 [mask-image:radial-gradient(100%_60%_at_bottom_left,white,transparent)]",
            "sm:opacity-100 sm:[mask-image:radial-gradient(100%_100%_at_top_left,white,transparent)]",
            "dark:invert-75",
          )}
        />

        <div className="py-12">
          <header className="mx-auto max-w-7xl px-6 lg:px-8 xl:px-0">
            <div className="mx-auto max-w-2xl md:mx-0">
              <h1 className="text-3xl font-black tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl">
                {vertical ? (
                  <FormattedMessage
                    id="1Edr+3"
                    defaultMessage="Balanços de {vertical}"
                    description="Financials page"
                    values={{
                      vertical: getPlatformVerticalTitle(vertical),
                    }}
                  />
                ) : (
                  <FormattedMessage id="kvazcP" defaultMessage="Balanços" description="Financials page" />
                )}
              </h1>

              <p className="mt-2 text-sm leading-7 tracking-wider text-slate-600 dark:text-slate-300 sm:text-lg sm:tracking-wide">
                <FormattedMessage
                  id="I9P0jY"
                  defaultMessage="Balanços atualizados de mais de 6000 Stocks, REITs, FIIs e Ações para análise customizada com mais de 900 indicadores disponíveis."
                  description="Financials page"
                />
              </p>
            </div>
          </header>
        </div>
        <Separator className="bg-gray-950/10" />
      </div>
    </div>
  );
}
